import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import {
  ErrorDetails,
  TransportTypeRequestDTO
} from "app/services/authentication/connection/interfaces/apiInterfaces";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ServiceTypeDTO } from "./addServiceType.command";

export class UpdateServiceTypeCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IUpdateServiceTypeCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'carriers/{carrierId}/serviceTypes/{serviceTypeId}/update';

  public setParametersUrl(carrierId: string, serviceTypeId: number) {
    this._commandUrl = this._commandUrl.replace(
        '{carrierId}',
        carrierId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
        '{serviceTypeId}',
        serviceTypeId.toString()
    );
  }

  public override setParameters(parameters: IUpdateServiceTypeCommandParameters) {
    this._commandBody = parameters;
  }
}

export interface IUpdateServiceTypeCommandParameters
  extends ServiceTypeDTO,
    ICommandParameters {}
